import { MultiString } from "../../../../library-js/i18n/MultiString";

export enum TagInfoID
{
  THREE_D,
  TWO_D,
  IMAGE_EDITING,
  VECTOR_GRAPHICS,
  VIDEO_EDITING
}

export class TagInfos 
{
  static readonly [ TagInfoID.TWO_D ]:MultiString = 
  {
    en: "2D"
  }

  static readonly [ TagInfoID.THREE_D ]:MultiString = 
  {
    en: "3D"
  }

  static readonly [ TagInfoID.IMAGE_EDITING ]:MultiString = 
  {
    en: "IMAGE EDITING"
  }

  static readonly [ TagInfoID.VIDEO_EDITING ]:MultiString = 
  {
    en: "VIDEO EDITING"
  }

  static readonly [ TagInfoID.VECTOR_GRAPHICS ]:MultiString = 
  {
    en: "VECTOR GRAPHICS"
  }

  

}